var mp = mp || {};

// FancyBox
//-----------------------------------------------------------------
mp.fancyBox = function () {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }

    $trigger.fancybox({
        touch: true,
        infobar: false,
        buttons: ["close"],
    });
};

// Tabs
//-----------------------------------------------------------------
mp.tabs = function () {
    var $element = $("[data-toggle-tab]");

    if (!$element.length) {
        return;
    }

    $(document).on("click", "[data-toggle-tab]", function (e) {
        e.preventDefault();

        $target = $(this).data("toggle-tab");
        $("[data-toggle-tab], [data-toggle-content]").removeClass("active");

        $(this).addClass("active");
        $('[data-toggle-content="' + $target + '"]').addClass("active");
    });
};

// Toggle
//-----------------------------------------------------------------
mp.toggle = function () {
    var $element = $("[data-toggle]");

    if (!$element.length) {
        return;
    }

    $(document).on("click", "[data-toggle]", function (e) {
        e.preventDefault();

        // OPEN ALL
        $target = $(this).data("toggle");

        $(this).toggleClass("active").parent().toggleClass("active");
        $('[data-toggle-content="' + $target + '"]').toggleClass("active");

        // OPEN ONE
        // $already_active = $(this).hasClass("active");

        // $target = $(this).data("toggle");
        // $('[data-toggle], [data-toggle-content]').removeClass('active');
        // $(this).parent().removeClass("active");

        // if ($already_active == false) {
        //     $(this).addClass("active").parent().addClass("active");
        //     $('[data-toggle-content="'+$target+'"]').addClass("active");
        // }
    });

    $(document).on("click", "[data-close]", function (e) {
        $("[data-toggle], [data-toggle-content]").removeClass("active");
    });

    $(document).on("click", ".projects--hero .pins", function (e) {
        if ($(e.target).hasClass("pins")) {
            $("[data-toggle], [data-toggle-content]").removeClass("active");
        }
    });
};

// Init Selectric
//-----------------------------------------------------------------
mp.selectric = function () {
    var $trigger = $(".form__select");

    if (!$trigger.length) {
        return;
    }

    if ($trigger.hasClass("js_setLicencePrice")) {
        mp.setPrice();
    }

    $trigger.selectric({
        disableOnMobile: false,
        nativeOnMobile: true,
    });
};

// Datepicker
//-----------------------------------------------------------------
mp.datepicker = function () {
    var $element = $("[data-date]");

    if (!$element.length) {
        return;
    }

    $element.datepicker({
        startDate: "today",
        language: "hr",
        weekStart: 1,
        format: "dd.mm.yyyy.",
    });

    $element.on("changeDate", function () {
        $element.find("input").val($element.datepicker("getFormattedDate"));
    });
};

// Datepicker
//-----------------------------------------------------------------
mp.inView = function () {
    const { animate, inView } = Motion;

    var $element = $("[data-animation]");

    inView(
        $element,
        (element) => {
            animation = $(element).data("animation");

            if (animation == "numbers") {
                to = $(element).data("to");
                animate(0, to, {
                    duration: 2,
                    ease: "easeOut",
                    onUpdate: (latest) =>
                        (element.innerHTML =
                            Math.round(latest).toLocaleString("hr-HR")),
                });
            }

            if (animation == "fadeIn") {
                animate(
                    element,
                    { opacity: 1 },
                    {
                        duration: 2,
                        easing: [0.32, 0, 0.67, 0],
                    },
                );
            }
        },
        { margin: "-150px 0px -150px 0px" },
    );
};

mp.scroller = function () {
    var $element = $(".scroller");

    if (!$element.length) {
        return;
    }

    $element.each(function () {
        const $scroller = $(this);

        // Add data-animated="true"
        $scroller.attr("data-animated", "true");

        // Get the children of .scroller__inner
        const $scrollerInner = $scroller.find(".scroller__inner");
        const $scrollerContent = $scrollerInner.children();

        // Clone each item and append it
        $scrollerContent.each(function () {
            const $duplicatedItem = $(this).clone();
            $duplicatedItem.attr("aria-hidden", "true");
            $scrollerInner.append($duplicatedItem);
        });
    });
};

$(document).ready(function () {
    mp.fancyBox();
    mp.tabs();
    mp.toggle();
    mp.selectric();
    // mp.datepicker();
    mp.inView();
    mp.scroller();
});
